<template>
    <section class="practice">
        <div class="row">
            <aside class="col-md-3 col-sm-12 cus-sidebar">
                <practiceSidebar />
            </aside>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>
            <div v-if="!isLoading" id="content" class="content dailyReport col-md-9 col-sm-12">
                <div class="material-box bg-white">
                    <!-- begin page-header -->
                    <div class="col-md-12 top-title">
                        <h3>Daily Report </h3>
                    </div>
                    <!-- begin section-container -->
                    <div class="col-md-12">
                        <div class="section-container section-with-top-border patient_report">
                            <div class="inner_patient_report">
                                <div class="row" style="align-items: flex-end;">
                                    <div class="col-lg-4 col-md-6 col-sm-6 form-group calendar-field">
                                        <label>Select Date:</label>
                                        <input type="date" class=" form-control" v-model="form.date">
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 form-group">
                                        <input value="Submit" @click="dailyReport"
                                            class="btn btn-primary btn-blue m-t-20" type="button"
                                            style="margin-right: 2px;box-shadow: 0 1px #144f83;">
                                        <button @click="printReport" class="btn btn-default m-t-20 btn-white"
                                            id="ShowReport">
                                            <i class="fa fa-print"></i> Print Report
                                        </button>
                                    </div>
                                </div>

                                <!-- begin panel -->
                                <div id="print-daily">
                                    <div class="row">
                                        <div class="col-lg-12 title"> <br>
                                            <h5 class="color-grey"><b>Daily Report</b></h5>
                                            <h5 class="color-grey"><b style=" display:block; letter-spacing: 0.6px;">{{
                                                    loginUser.PracticeName }}{{ user.name ? " - " + user.name : "" }}</b>
                                            </h5>
                                            <h5 class="color-grey" style="padding-bottom:15px"><b>Results for {{ date
                                                    }}</b>
                                            </h5>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="table-responsive w-table-responsive">
                                                <table id="report-tbl"
                                                    class="table daily-repot-table table-td-valign-middle table-td-valign-main weekly comnTbl">
                                                    <thead>
                                                        <tr>
                                                            <th>Practice</th>
                                                            <th>Monthly Goal</th>
                                                            <th>Goal</th>
                                                            <th>Actual</th>
                                                            <th>Difference</th>
                                                            <th>Success Rate</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>New patient</td>
                                                            <td>{{ formatWhole(monthlyReport.Focus1MonthlyGoal) }}</td>
                                                            <td>{{ f1g }}</td>
                                                            <td>{{ f1a }} / {{ f1g }}</td>
                                                            <td>{{ calDifference(report.Focus1Goal, report.Focus1Actual)
                                                                }}</td>
                                                            <td>{{ calculatePer(report.Focus1Actual, report.Focus1Goal)
                                                                }}%</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Report of Findings</td>
                                                            <td>-</td>
                                                            <td>-</td>
                                                            <td>{{ f2g }} / {{ f2a }}</td>
                                                            <td>-</td>
                                                            <td>{{ calculatePer(report.Focus2Actual, report.Focus2Goal)
                                                                }}%</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Patient Visits</td>
                                                            <td>{{ formatWhole(monthlyReport.Focus3MonthlyGoal) }}</td>
                                                            <td>{{ f3g }}</td>
                                                            <td>{{ f3a }} / {{ f3g }}</td>
                                                            <td>{{ calDifference(report.Focus3Goal, report.Focus3Actual)
                                                                }}</td>
                                                            <td>{{ calculatePer(report.Focus3Actual, report.Focus3Goal)
                                                                }}%</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Care Plan Renewals</td>
                                                            <td>-</td>
                                                            <td>-</td>
                                                            <td>{{ f4g }} / {{ f4a }}</td>
                                                            <td>-</td>
                                                            <td>{{ calculatePer(report.Focus4Actual, report.Focus4Goal)
                                                                }}%</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Revenue</td>
                                                            <td>{{ formatRevenue(monthlyReport.Focus5MonthlyGoal) }}</td>
                                                            <td>{{ f5g }}</td>
                                                            <td>{{ f5a }} / {{ f5g }}</td>
                                                            <td>{{ calDifference(report.Focus5Goal, report.Focus5Actual,
                                                                true) }}</td>
                                                            <td>{{ calculatePer(report.Focus5Actual, report.Focus5Goal)
                                                                }}%</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div>
                                                <br>
                                                <span class="pull-left"><b>{{ date }}</b></span>
                                                <span class="pull-right"><b
                                                        style="width:190px; display:block; letter-spacing: 0.6px;">{{
                                                        loginUser.PracticeName }}</b></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- end panel -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from 'vue';
import practiceSidebar from "./../Practice/components/Sidebar.vue";
import userAPI from "../userApi";
import moment from 'moment'
import jsPDF from 'jspdf';

Vue.use(jsPDF)
export default {
    name: "practice_dashboard",
    components: {
        practiceSidebar,
    },
    data() {
        return {
            isLoading: false,
            date: moment().subtract(1, 'days').format("dddd, MMMM D, YYYY"),
            loginUser: {},
            table: {},
            users: [{
                id: 0,
                name: 'Practice'
            }],
            user: {},
            form: {
                UserID: 0,
                date: moment().subtract(1, 'days').format('Y-MM-DD'),
            },
            monthlyReport: {},
            years: [],
            report: {}
        }
    },
    methods: {

        calDifference(goal, actual, rev = false) {
            let focus1Goal = Math.round(parseFloat(goal != null ? goal : 0));
            let focus1Actual = Math.round(parseFloat(actual != null ? actual : 0));
            let diff = focus1Actual - focus1Goal;

            if (diff < 0) {
                let absDiff = Math.abs(diff).toLocaleString();
                return rev ? '-' + absDiff : '-' + absDiff;
            } else {
                let posDiff = diff.toLocaleString();
                return rev ? '+' + posDiff : '+' + posDiff;
            }
        },
        calculatePer(actual, goal) {
            actual = actual != null ? actual : 0;
            goal = goal != null ? goal : 0;
            let rate = 0;
            if (parseFloat(actual) !== 0 && parseFloat(goal) !== 0) {
                rate = Math.round((parseFloat(actual) / parseFloat(goal)) * 100);
            } else {
                rate = 0;
            }
            return rate;
        },
        dailyReport() {
            this.date = moment(this.form.date).format("dddd, MMMM D, YYYY");
            if (this.form.UserID != 0) {
                this.user = this.users.find(user => user.id === this.form.UserID);
            }
            else {
                this.user = {}
            }
            userAPI.dailyReport({
                PracticeID: this.loginUser.PracticeID,
                ...this.form
            },
                res => {
                    this.report = res.data.data;
                    this.getMonthlyFocusData()
                },
                err => {
                    console.log(err);
                })
        },
        getMonthlyFocusData() {
            userAPI.getMonthlyFocusData({
                PracticeID: this.loginUser.PracticeID,
                ...this.form
            },
                res => {
                    this.monthlyReport = res.data.data;
                },
                err => {
                    console.log(err);
                })
        },
        resetReport() {
            this.form = {
                UserID: 0,
                year: moment().format('Y'),
                FocusCode: this.focusData.FocusCode
            };
            this.getReportData();
        },
        printReport() {
            let print = document.getElementById('print-daily');

            const doc = new jsPDF()
            doc.html(print, {
                callback: function (doc) {
                    doc.save("Daily-Report.pdf");
                },
                margin: [10, 10, 10, 10],
                autoPaging: 'text',
                x: 0,
                y: 0,
                width: 190,
                windowWidth: 875
            });
        },
        getUsersByPractice() {
            this.isLoading = true;
            userAPI.getUsersByPractice({ practiceID: this.loginUser.PracticeID },
                res => {
                    res.data.data.forEach(element => {
                        this.users.push({
                            'id': element.UserID,
                            'name': `${element.FirstName} ${element.LastName}`
                        })
                    });
                    this.isLoading = false;

                },
                err => {
                    console.log(err);
                    this.isLoading = false;

                })
        },

        formatWhole(value) {
            if (value === null || value === undefined || isNaN(value) || value === '') {
                return 0;
            }
            return Math.round(parseFloat(value));
        },
        formatRevenue(value) {
            if (value === null || value === undefined || isNaN(value) || value === '') {
                return 0;
            }
            return Math.round(parseFloat(value)).toLocaleString();
        },
    },
    mounted() {
        this.loginUser = JSON.parse(localStorage.getItem('userDetails'));
        this.getUsersByPractice()
        this.dailyReport()
    },
    computed: {
        f1g() {
            return this.report && this.report.Focus1Goal != null ? Math.round(parseFloat(this.report.Focus1Goal)) : 0;
        },
        f1a() {
            return this.report && this.report.Focus1Actual != null ? Math.round(parseFloat(this.report.Focus1Actual)) : 0;
        },
        f2g() {
            return this.report && this.report.Focus2Goal != null ? Math.round(parseFloat(this.report.Focus2Goal)) : 0;
        },
        f2a() {
            return this.report && this.report.Focus2Actual != null ? Math.round(parseFloat(this.report.Focus2Actual)) : 0;
        },
        f3g() {
            return this.report && this.report.Focus3Goal != null ? Math.round(parseFloat(this.report.Focus3Goal)) : 0;
        },
        f3a() {
            return this.report && this.report.Focus3Actual != null ? Math.round(parseFloat(this.report.Focus3Actual)) : 0;
        },
        f4g() {
            return this.report && this.report.Focus4Goal != null ? Math.round(parseFloat(this.report.Focus4Goal)) : 0;
        },
        f4a() {
            return this.report && this.report.Focus4Actual != null ? Math.round(parseFloat(this.report.Focus4Actual)) : 0;
        },
        f5g() {
            return this.report && this.report.Focus5Goal != null ? Math.round(parseFloat(this.report.Focus5Goal)).toLocaleString() : 0;
        },
        f5a() {
            return this.report && this.report.Focus5Actual != null ? Math.round(parseFloat(this.report.Focus5Actual)).toLocaleString() : 0;
        },
    }
}

</script>

<style>
.calendar-field input[type="date"]::-webkit-calendar-picker-indicator {
    opacity: 0.4;
}

.calendar-field input[type="date"]::-webkit-inner-spin-button,
.calendar-field input[type="date"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
    opacity: 0.1;
    font-size: 20px;
    transform: rotate(20deg);
}

.calendar-field input[type="date"] {
    -moz-appearance: textfield;
}
</style>
<style>
table.table.daily-repot-table tr td {
    border-color: #dddddd !important;
}
</style>